import { RSAA } from 'redux-api-middleware';
import { ACTIVATE } from './types';

export const pairedDevicesActivateRequestAction = ({ pairingCode }) => ({
  [RSAA]: {
    endpoint: `/v3/pairing/${pairingCode}`,
    method: 'POST',
    credentials: 'include',
    types: [
      ACTIVATE.REQUEST,
      {
        type: ACTIVATE.SUCCESS,
        meta: { pairingCode },
      },
      {
        type: ACTIVATE.FAILURE,
        meta: { pairingCode },
      },
    ],
  },
});
